module.exports = __webpack_public_path__ + "img/hr-sand-decal-04.459ff976.png";